// @mui material components
import Grid from "@mui/material/Grid";

// Ajce Hostel App React components
import MDBox from "components/MDBox";


// Ajce Hostel App React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AddStudentForm from "./components/AddStudentForm";

function AddStudents() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
         <MDBox p={5}>
            <AddStudentForm />
         </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddStudents;
